<template>
  <VModal @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-lg mx-auto">
        <div class="rounded shadow-lg bg-white">
          <div class="px-4 sm:px-6 py-5 border-b">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Send Test Email</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="p-4 sm:p-6 space-y-8">
            <BaseFetchData :action="loadFromOptions">
              <template #default="fetchDataProps">
                <BaseVeeForm
                  v-if="fetchDataProps.status.resolved"
                  :action="sendTest"
                  @success="onSent"
                >
                  <template #default="formProps">
                    <div class="space-y-8">
                      <div v-if="sent" class="rounded-md bg-green-50 p-4 border border-green-600">
                        <div>
                          <h3 class="text-sm font-medium text-green-800">
                            Email was sent succesfully! Check your inbox.
                          </h3>
                        </div>
                      </div>
                      <BaseFormTextFieldWithValidator
                        v-model="formData.to"
                        v-bind="toFieldProps"
                        :disabled="formProps.isPending"
                      />

                      <BaseFormSelectFieldWithValidator
                        v-model="formData.from"
                        v-bind="fromFieldProps"
                        :disabled="formProps.isPending"
                      />

                      <BaseButton primary :disabled="formProps.isPending || formProps.invalid">
                        Send
                      </BaseButton>
                    </div>
                  </template>
                </BaseVeeForm>
              </template>
            </BaseFetchData>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { accountThirdPartyServicesClient, emailTemplateTestClient } from '@/api/clients';

export default {
  name: 'SendTestDialog',
  props: {
    accountId: {
      type: String,
      required: true,
    },
    emailTemplateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fromOptions: [],
      formData: {
        from: null,
        to: null,
      },
      sent: false,
    };
  },
  created() {
    this.formData.to = this.$user?.email;
  },
  computed: {
    toFieldProps() {
      return {
        validator: {
          vid: 'to',
          name: 'to',
          rules: {
            required: true,
          },
        },
        field: {
          id: 'to',
          label: 'To',
        },
      };
    },
    fromFieldProps() {
      return {
        validator: {
          vid: 'from',
          name: 'from',
          rules: {
            required: true,
          },
        },
        field: {
          id: 'from',
          label: 'From',
          options: this.fromOptions,
        },
      };
    },
  },
  methods: {
    async loadFromOptions() {
      try {
        const response = await accountThirdPartyServicesClient.list(this.accountId, {
          params: {
            filter: {
              channel: 'mail',
              active: true,
            },
          },
        });

        this.fromOptions = response.data.data.map((option) => ({
          label: option.email_address,
          value: option.id,
        }));
      } catch (error) {
        //
      }
    },
    sendTest() {
      this.sent = null;
      return emailTemplateTestClient.send(this.emailTemplateId, this.formData);
    },
    onSent() {
      this.sent = new Date().getTime();
    },
  },
};
</script>
